<template>
  <div class="container">
    <form
      v-if="!success"
      @submit.prevent="isUpdate ? updateStakeholder() : addStakeHolder()"
    >
      <h2>
        <span v-if="isUpdate">
          {{ $t('stakeholderpage.update') }}
        </span>
        <span v-else>{{ $t('stakeholderpage.create') }}</span>
      </h2>

      <div class="p-input mb-3">
        <label
          for="stakeholder"
          class="required-input"
        >{{ $t('entity.stakeholder.stakeholderId') }}</label>

        <strong v-if="isUpdate"> : {{ v$.stakeholder.stakeholderId.$model }}</strong>

        <InputText
          v-if="!isUpdate"
          id="stakeholder"
          v-model.trim="v$.stakeholder.stakeholderId.$model"
          class="col-12 mt-2"
          :class="{'invalid-input': v$.stakeholder.stakeholderId.$error } "
          type="text"
          autocomplete="on"
          required
        />
        <div
          v-for="error of v$.stakeholder.stakeholderId.$errors"
          :key="error.$uid"
          class="input-errors"
        >
          <div class="error-msg">
            {{ error.$message }}
          </div>
        </div>
      </div>

      <div class="p-input mb-3">
        <label
          for="lastname"
          class="required-input"
        >{{ $t('entity.stakeholder.name') }}</label>
        <InputText
          id="lastname"
          v-model="v$.stakeholder.name.$model"
          class="col-12 mt-2"
          :class="{'invalid-input': v$.stakeholder.name.$error }"
          type="text"
          autocomplete="family-name"
          required
        />
        <div
          v-for="error of v$.stakeholder.name.$errors"
          :key="error.$uid"
          class="input-errors"
        >
          <div class="error-msg">
            {{ error.$message }}
          </div>
        </div>
      </div>

      <Message
        v-if="errors.length > 0"
        severity="error"
        :closable="false"
      >
        <ul class="list-none m-0 p-0">
          <li
            v-for="error of errors"
            :key="error"
          >
            {{ $t(error) }}
          </li>
        </ul>
      </Message>

      <div class="my-3 flex justify-content-between flex-wrap">
        <Button
          :label="$t('action.back')"
          icon="pi pi-arrow-left"
          class="p-button-secondary p-button-outlined p-button-rounded"
          @click="toStakeholderTable"
        />
        <Button
          type="submit"
          :label="isUpdate ? $t('action.crud.update') : $t('action.crud.create')"
          icon="pi pi-save"
          :disabled="addButtonDisabled"
          :loading="isSaving"
          class="p-button-rounded p-button-outlined"
        />
      </div>
    </form>
  </div>
</template>

<script>
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Message from 'primevue/message';
import {useVuelidate} from '@vuelidate/core';
import {required} from '@/i18n/i18nValidators';

export default {
  name: 'StakeHolderForm',
  components: { InputText, Button, Message },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  data() {
    return {
      stakeholder: {
        id: null,
        stakeholderId: null,
        name: null
      },
      errors: [],
      success: false,
      isSaving: false,
      isUpdate: false,
    }
  },
  validations() {
    return {
      stakeholder: {
        stakeholderId: { required },
        name: { required }
      }
    }
  },
  computed: {
    addButtonDisabled() {
      return this.v$.$invalid;
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.fetchStakeholder(this.$route.params.id)
      this.isUpdate = true;
    }
  },
  methods: {
    async fetchStakeholder() {
      this.stakeholder = await this.$stakeHolderService.fetchStakeholder(this.$route.params.id)
    },
    async addStakeHolder() {
      this.errors = [];
      const isFormValid = await this.v$.$validate();
      if (!isFormValid) return;

      this.isSaving = true;

      try {
        await this.$stakeHolderService.addStakeholder(this.stakeholder)
        this.success = true;
        this.isSaving = false;
        this.$emitter.emit('toast', { severity: 'success', message: 'stakeholderpage.messages.createSuccess' })
        this.toStakeholderTable()
      } catch (e) {
        this.success = false;
        this.errors = e.response.data;
        this.isSaving = false;
      }
    },
    async updateStakeholder() {
      this.errors = [];
      const isFormValid = await this.v$.$validate();
      if (!isFormValid) return;

      this.isSaving = true;

      try {
        await this.$stakeHolderService.updateStakeholder(this.stakeholder)
        this.success = true;
        this.isSaving = false;
        this.$emitter.emit('toast', { severity: 'success', message: 'stakeholderpage.messages.updateSuccess' })
        this.toStakeholderTable()
      } catch (e) {
        this.success = false;
        this.errors = e.response.data;
        this.isSaving = false;
      }
    },
    toStakeholderTable() {
      this.$router.push({ name: 'stakeholder' })
    }
  }
}
</script>

<style scoped lang="scss">

</style>

